import React from "react";

export default () => (
  <svg width="100%" height="100%" viewBox="0 0 440 120">
    <path
      d="M51 34v23H0V34h51zM313 1v56h-51V1h51zM181 7v50h-51V7h51zm259 8v42h-51V15h51zm-323 9v33H66V24h51zm259-5v38h-51V19h51zM246 0v57h-51V0h51z"
      fill="#F09"
    />
    <path
      d="M51 109V64H0v45h51zm262-16V64h-51v29h51zm-132 28V64h-51v57h51zm259-40V64h-51v17h51zm-323 0V64H66v17h51zm259 21V64h-51v38h51zm-130-5V64h-51v33h51z"
      fill="#09F"
    />
  </svg>
);
